import script from "./base-info-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./base-info-list.vue?vue&type=script&lang=ts&setup=true"

import "./base-info-list.vue?vue&type=style&index=0&id=3201f676&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3201f676"]])

export default __exports__